import { useField } from "formik";
import { ReportingMelcoMachineStatisticsModelsMachineListItem } from "melco-shared-logic";
import { useCallback } from "react";

export const useAddRemoveMachine = () => {
  const [{ value: machines }, , { setValue: setMachines, setError }] =
    useField<ReportingMelcoMachineStatisticsModelsMachineListItem[]>(
      "machine_list"
    );

  const isAlreadyAdded = (
    machine: ReportingMelcoMachineStatisticsModelsMachineListItem
  ) => {
    return (
      machine?.device_id &&
      machines?.find(
        (c: ReportingMelcoMachineStatisticsModelsMachineListItem) =>
          c.device_id == machine.device_id
      )
    );
  };

  const addMachines = useCallback(
    (toAdd: ReportingMelcoMachineStatisticsModelsMachineListItem[]) => {
      const addedMachines = toAdd
        .filter((c) => !isAlreadyAdded(c))
        .map((machine) => {
          const {
            serial_number,
            name,
            registered_date,
            last_sync_date,
            device_id,
          } = machine;
          return {
            serial_number: serial_number,
            name: name,
            registered_date: registered_date,
            last_sync_date: last_sync_date,
            device_id: device_id,
          };
        });
      setMachines([...(machines ?? []), ...addedMachines]);
      return addedMachines;
    },
    [machines, setMachines]
  );

  const removeMachines = useCallback(
    (toRemove: { device_id: string }[]) => {
      const device_idsToRemove = toRemove.map(
        (d: ReportingMelcoMachineStatisticsModelsMachineListItem) => d.device_id
      );
      setMachines(
        machines.filter(
          (c: ReportingMelcoMachineStatisticsModelsMachineListItem) =>
            !device_idsToRemove.includes(c.device_id!)
        )
      );
      setError(undefined);
    },
    [machines, setMachines]
  );

  return {
    machines,
    isAlreadyAdded,
    addMachines,
    removeMachines,
  };
};
